class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimer = null;

    this.onMouseEnterHandler = this.onMouseEnter.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeave.bind(this);
    this.onSummaryClickHandler = this.onSummaryClick.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnterHandler);
    this.addEventListener('mouseleave', this.onMouseLeaveHandler);
    this.summary.addEventListener('click', this.onSummaryClickHandler);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  isDesktopViewport() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onMouseEnter() {
    if (!this.isDesktopViewport()) return;

    window.clearTimeout(this.closeTimer);
    this.open();
  }

  onMouseLeave() {
    if (!this.isDesktopViewport()) return;

    this.closeTimer = window.setTimeout(() => this.close(), 120);
  }

  onSummaryClick(event) {
    if (!this.isDesktopViewport()) return;

    if (event.detail > 0) {
      event.preventDefault();
    }
  }

  open() {
    const siblingMenus = this.closest('.header__inline-menu')?.querySelectorAll('header-menu details[open]');

    siblingMenus?.forEach((menu) => {
      if (menu !== this.mainDetailsToggle) {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.setAttribute('aria-expanded', false);
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }
}

customElements.define('header-menu', HeaderMenu);
